export default __webpack_public_path__ + "static/media/img-04.4d5de099.png";